<template>
  <div v-if="screener">
    <!-- Buy Ticket Button -->
    <v-btn
      v-if="!isScreeningArchive && isScreeningPaid(screener) && (!isConsumerPurchased(screener.id) || isConsumerSubscribed) && !isConsumerEnrolled(screener.id)"
      v-bind="buttonProps"
      color="transparent"
      class="white--text mx-0 btn-watch"
      :class="buttonDisplayMode === 'icon' ? 'icon-button' : 'text-button'"
      :flat="buttonDisplayMode === 'icon'"
      :disabled="screener.is_geo_blocked"
      @click.stop="$emit('onBuyTicket', screener)"
    >
      <template v-if="buttonDisplayMode === 'icon'">
        <v-img :src="playIconSrc" class="play-icon" contain></v-img>
      </template>
      <template v-else>
        <span v-if="isEmbedMode">{{ $t(`${eventPrefix}.btn.watch`) }}</span>
        <span v-else>{{ $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Watch Button -->
    <v-btn
      v-else-if="isConsumerEnrolled(screener.id)"
      v-bind="buttonProps"
      color="transparent"
      class="white--text mx-0 btn-watch"
      :class="buttonDisplayMode === 'icon' ? 'icon-button' : 'text-button'"
      :flat="buttonDisplayMode === 'icon'"
      :disabled="screener.is_geo_blocked"
      @click.stop="$emit('onWatch', screener)"
    >
      <template v-if="buttonDisplayMode === 'icon'">
        <v-img :src="playIconSrc" class="play-icon" contain></v-img>
      </template>
      <template v-else>
        <span v-if="isEmbedMode">{{ $t(`${eventPrefix}.btn.watch`) }}</span>
        <span v-else>{{ $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Participate Button -->
    <v-btn
      v-if="showParticipateMenu()"
      v-bind="buttonProps"
      color="transparent"
      class="white--text mx-0 btn-participate-watch"
      :flat="buttonDisplayMode === 'icon'"
      :disabled="isDisabledWatch()"
      @click.stop="$emit('onParticipate', screener)"
      elevation="0"
    >
      <template v-if="buttonDisplayMode === 'icon'">
        <v-img :src="playIconSrc" class="play-icon"  contain></v-img>
      </template>
      <template v-else>
        <span v-if="isEmbedMode">{{ $t(`${eventPrefix}.btn.watch`) }}</span>
        <span v-else>{{ $t(`${eventPrefix}.btn.watch`) }}</span>
      </template>
    </v-btn>

    <!-- Venue event Buy Ticket Button -->
    <v-btn
      v-if="_shouldShowBuyVenueTicketBtn()"
      v-bind="buttonProps"
      color="transparent"
      class="white--text mr-0"
      @click.stop="$emit('onBuyVenueTicket', screener)"
    >
      <span>{{ $t("screener.btn.buy_venue_ticket") }}</span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isDatePast } from "@/helpers";

export default {
  name: "ScreenerButton",
  props: {
    screener: {
      type: Object,
      default: null
    },
    buttonProps: {
      type: Object,
      default: () => ({})
    },
    eventPrefix: {
      type: String,
      default: "screener",
    },
    buttonDisplayMode: {
      type: String,
      default: "icon", 
      validator: (value) => ["icon", "text"].includes(value),
    },
  },
  computed: {
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid",
      isScreeningSeatsAvailable: "isScreeningSeatsAvailable"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      isConsumerSubscribed: "isSubscribed"
    }),
    ...mapGetters("app", {
      isEmbedMode: "isEmbedMode",
    }),
    isScreeningArchive: function(){
      //TEMP:: VOD events can't be archived
      if(this.screener.is_vod_event){
        return false;
      }
      return isDatePast(this.screener.registration_ends_at);
    },
    isArchiveMenu: function(){
      return this.$route.name == 'screeners.archive';
    },
    isDarkTheme() {
      return this.$store.getters["app/darkMode"];
    },
    playIconSrc() {
      return this.isDarkTheme
        ? require("@/assets/screen-white.png")
        : require("@/assets/screen-black.png");
    }
  },
  methods: {
    showParticipateMenu(){
      if(this.isArchiveMenu){
        return false;
      }

      if(this.isScreeningPaid(this.screener) && !this.isConsumerPurchased(this.screener.id)){
        return false;
      }

      return !this.isConsumerEnrolled(this.screener.id);
    },
    _shouldShowBuyVenueTicketBtn(){
      // If the event is not of both the types, never show
      if(this.screener.event_type != this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL_AND_PHYSICAL){
        return false;
      }

      // If the event is paid and purchased by the user then show
      if(this.isScreeningPaid(this.screener) && this.isConsumerPurchased(this.screener.id)){
        return true;
      }

      // If the event is paid/free & the user is enrolled then show
      if(this.isConsumerEnrolled(this.screener.id)){
        return true;
      }

      // If the event is geo-blocked then show
      if(this.screener.is_geo_blocked){
        return true;
      }
    },
    isDisabledWatch() {
      if(this.screener.is_geo_blocked) {
        return true;
      }

      if(this.screener.vod_availability == 0) {
        return true;
      }

      if(!this.isScreeningSeatsAvailable(this.screener)) {
        return true;
      }
      
    }
  }
};
</script>

<style scoped>
.btn-participate-watch, .btn-watch {
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  white-space: nowrap;
}

.text-button {
  min-width: 100px;
  max-width: fit-content;
  width: auto !important;
}

.icon-button {
  width: 100px !important;
  padding: 0;
}

/* Adjust for mobile */
@media only screen and (max-width: 600px) {
  .text-button {
    min-width: 50px;
  }

  .icon-button {
    width: 50px !important;
    height: 50px !important;
  }
  .play-icon {
    width: 50px;
    height: 70%;
    object-fit: contain;
  }
}

.play-icon {
  width: 100px;
  height: 70%;
  object-fit: contain;
}

</style>
